import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { usePartnerQuotaUIContext } from "./PartnerQuotaUIContext";
import PartnerQuotaTable from "./partner-quota-table/PartnerQuotaTable";
import { PartnerQuotaFilter } from "./partner-quota-filter/PartnerQuotaFilter";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export const PartnerQuotaCard = () => {
  const partnerQuotaUIContext = usePartnerQuotaUIContext();
  const partnerQuotaUIProps = useMemo(() => {
    return {
      newPartnerQuotaButtonClick: partnerQuotaUIContext.newPartnerQuotaButtonClick,
    };
  }, [partnerQuotaUIContext]);

  return (
    <Card>
      <CardHeader title="Stock Mitra">
        <CardHeaderToolbar>
          {BlockOrg() && RoleChecker("Create", "partner-quota") && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={partnerQuotaUIProps.newPartnerQuotaButtonClick}
            >
              Kelola Stok
            </button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <PartnerQuotaFilter />
        <PartnerQuotaTable />
      </CardBody>
    </Card>
  );
};
